import apiServiceApiGateway from 'config/apiServiceApiGateway'
import {
  generateExternalType,
  gengerateVendorPathExtension,
} from 'features/Account/utils/generateVendorHeader'

import {
  GetAllPageIDListResponsesInterface,
  QueryURLPageIDListType,
  CreateUpadatePageIDResponseType,
  PostPageIDRequestType,
  PutPageIDRequestType,
  GetPagePermissionOptionsResponseType,
  GetDetailPageIDResponseType,
  GetJSONPageIDDetailsResponseType,
} from 'features/Account/@types/adminAccessPageIDList'

export const getAllPageIDList = async (query: QueryURLPageIDListType, isVendor = false) =>
  apiServiceApiGateway.Get<GetAllPageIDListResponsesInterface>({
    url: `/auth/internal/v1/page${gengerateVendorPathExtension(isVendor)}`,
    params: query,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const getDetailPageIDAPI = async (pageId: string, isVendor = false) =>
  apiServiceApiGateway.Get<GetDetailPageIDResponseType>({
    url: `/auth/internal/v1/page${gengerateVendorPathExtension(isVendor)}/${pageId}`,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const postPageIDAPI = (payload: PostPageIDRequestType, isVendor = false) =>
  apiServiceApiGateway.Post<CreateUpadatePageIDResponseType>({
    url: `/auth/internal/v1/page${gengerateVendorPathExtension(isVendor)}`,
    data: payload,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const putPageIDAPI = ({
  id,
  payload,
  isVendor = false,
}: {
  id: string
  payload: PutPageIDRequestType
  isVendor?: boolean
}) =>
  apiServiceApiGateway.Put<CreateUpadatePageIDResponseType>({
    url: `/auth/internal/v1/page${gengerateVendorPathExtension(isVendor)}/${id}`,
    data: payload,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const getPagePermissionOptionsAPI = (isVendor = false) =>
  apiServiceApiGateway.Get<GetPagePermissionOptionsResponseType>({
    url: `/auth/internal/v1/permission/option`,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const getJSONPageIDDetailsAPI = (id: string, isVendor = false) =>
  apiServiceApiGateway.Get<GetJSONPageIDDetailsResponseType>({
    url: `/auth/internal/v1/page${gengerateVendorPathExtension(isVendor)}/json/:id`,
    urlParams: { id },
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })

export const postUploadJSONPageDetailsAPI = (data: { page_json: string }, isVendor = false) =>
  apiServiceApiGateway.Post<GetJSONPageIDDetailsResponseType>({
    url: `/auth/internal/v1/page${gengerateVendorPathExtension(isVendor)}/json`,
    data,
    config: { headers: { ...generateExternalType(isVendor ? 'vendor' : '') } },
  })
